const Options = [
	{ value: "Bulbasaur", label: "Bulbasaur", id: 1 },
	{ value: "Ivysaur", label: "Ivysaur", id: 2 },
	{ value: "Venusaur", label: "Venusaur", id: 3 },
	{ value: "Charmander", label: "Charmander", id: 4 },
	{ value: "Charmeleon", label: "Charmeleon", id: 5 },
	{ value: "Charizard", label: "Charizard", id: 6 },
	{ value: "Squirtle", label: "Squirtle", id: 7 },
	{ value: "Wartortle", label: "Wartortle", id: 8 },
	{ value: "Blastoise", label: "Blastoise", id: 9 },
	{ value: "Caterpie", label: "Caterpie", id: 10 },
	{ value: "Metapod", label: "Metapod", id: 11 },
	{ value: "Butterfree", label: "Butterfree", id: 12 },
	{ value: "Weedle", label: "Weedle", id: 13 },
	{ value: "Kakuna", label: "Kakuna", id: 14 },
	{ value: "Beedrill", label: "Beedrill", id: 15 },
	{ value: "Pidgey", label: "Pidgey", id: 16 },
	{ value: "Pidgeotto", label: "Pidgeotto", id: 17 },
	{ value: "Pidgeot", label: "Pidgeot", id: 18 },
	{ value: "Rattata", label: "Rattata", id: 19 },
	{ value: "Raticate", label: "Raticate", id: 20 },
	{ value: "Spearow", label: "Spearow", id: 21 },
	{ value: "Fearow", label: "Fearow", id: 22 },
	{ value: "Ekans", label: "Ekans", id: 23 },
	{ value: "Arbok", label: "Arbok", id: 24 },
	{ value: "Pikachu", label: "Pikachu", id: 25 },
	{ value: "Raichu", label: "Raichu", id: 26 },
	{ value: "Sandshrew", label: "Sandshrew", id: 27 },
	{ value: "Sandslash", label: "Sandslash", id: 28 },
	{ value: "Nidoranâ™€", label: "Nidoran (f)", id: 29 },
	{ value: "Nidorina", label: "Nidorina", id: 30 },
	{ value: "Nidoqueen", label: "Nidoqueen", id: 31 },
	{ value: "Nidoranâ™‚", label: "Nidoran (m)‚", id: 32 },
	{ value: "Nidorino", label: "Nidorino", id: 33 },
	{ value: "Nidoking", label: "Nidoking", id: 34 },
	{ value: "Clefairy", label: "Clefairy", id: 35 },
	{ value: "Clefable", label: "Clefable", id: 36 },
	{ value: "Vulpix", label: "Vulpix", id: 37 },
	{ value: "Ninetales", label: "Ninetales", id: 38 },
	{ value: "Jigglypuff", label: "Jigglypuff", id: 39 },
	{ value: "Wigglytuff", label: "Wigglytuff", id: 40 },
	{ value: "Zubat", label: "Zubat", id: 41 },
	{ value: "Golbat", label: "Golbat", id: 42 },
	{ value: "Oddish", label: "Oddish", id: 43 },
	{ value: "Gloom", label: "Gloom", id: 44 },
	{ value: "Vileplume", label: "Vileplume", id: 45 },
	{ value: "Paras", label: "Paras", id: 46 },
	{ value: "Parasect", label: "Parasect", id: 47 },
	{ value: "Venonat", label: "Venonat", id: 48 },
	{ value: "Venomoth", label: "Venomoth", id: 49 },
	{ value: "Diglett", label: "Diglett", id: 50 },
	{ value: "Dugtrio", label: "Dugtrio", id: 51 },
	{ value: "Meowth", label: "Meowth", id: 52 },
	{ value: "Persian", label: "Persian", id: 53 },
	{ value: "Psyduck", label: "Psyduck", id: 54 },
	{ value: "Golduck", label: "Golduck", id: 55 },
	{ value: "Mankey", label: "Mankey", id: 56 },
	{ value: "Primeape", label: "Primeape", id: 57 },
	{ value: "Growlithe", label: "Growlithe", id: 58 },
	{ value: "Arcanine", label: "Arcanine", id: 59 },
	{ value: "Poliwag", label: "Poliwag", id: 60 },
	{ value: "Poliwhirl", label: "Poliwhirl", id: 61 },
	{ value: "Poliwrath", label: "Poliwrath", id: 62 },
	{ value: "Abra", label: "Abra", id: 63 },
	{ value: "Kadabra", label: "Kadabra", id: 64 },
	{ value: "Alakazam", label: "Alakazam", id: 65 },
	{ value: "Machop", label: "Machop", id: 66 },
	{ value: "Machoke", label: "Machoke", id: 67 },
	{ value: "Machamp", label: "Machamp", id: 68 },
	{ value: "Bellsprout", label: "Bellsprout", id: 69 },
	{ value: "Weepinbell", label: "Weepinbell", id: 70 },
	{ value: "Victreebel", label: "Victreebel", id: 71 },
	{ value: "Tentacool", label: "Tentacool", id: 72 },
	{ value: "Tentacruel", label: "Tentacruel", id: 73 },
	{ value: "Geodude", label: "Geodude", id: 74 },
	{ value: "Graveler", label: "Graveler", id: 75 },
	{ value: "Golem", label: "Golem", id: 76 },
	{ value: "Ponyta", label: "Ponyta", id: 77 },
	{ value: "Rapidash", label: "Rapidash", id: 78 },
	{ value: "Slowpoke", label: "Slowpoke", id: 79 },
	{ value: "Slowbro", label: "Slowbro", id: 80 },
	{ value: "Magnemite", label: "Magnemite", id: 81 },
	{ value: "Magneton", label: "Magneton", id: 82 },
	{ value: "Farfetch'd", label: "Farfetch'd", id: 83 },
	{ value: "Doduo", label: "Doduo", id: 84 },
	{ value: "Dodrio", label: "Dodrio", id: 85 },
	{ value: "Seel", label: "Seel", id: 86 },
	{ value: "Dewgong", label: "Dewgong", id: 87 },
	{ value: "Grimer", label: "Grimer", id: 88 },
	{ value: "Muk", label: "Muk", id: 89 },
	{ value: "Shellder", label: "Shellder", id: 90 },
	{ value: "Cloyster", label: "Cloyster", id: 91 },
	{ value: "Gastly", label: "Gastly", id: 92 },
	{ value: "Haunter", label: "Haunter", id: 93 },
	{ value: "Gengar", label: "Gengar", id: 94 },
	{ value: "Onix", label: "Onix", id: 95 },
	{ value: "Drowzee", label: "Drowzee", id: 96 },
	{ value: "Hypno", label: "Hypno", id: 97 },
	{ value: "Krabby", label: "Krabby", id: 98 },
	{ value: "Kingler", label: "Kingler", id: 99 },
	{ value: "Voltorb", label: "Voltorb", id: 100 },
	{ value: "Electrode", label: "Electrode", id: 101 },
	{ value: "Exeggcute", label: "Exeggcute", id: 102 },
	{ value: "Exeggutor", label: "Exeggutor", id: 103 },
	{ value: "Cubone", label: "Cubone", id: 104 },
	{ value: "Marowak", label: "Marowak", id: 105 },
	{ value: "Hitmonlee", label: "Hitmonlee", id: 106 },
	{ value: "Hitmonchan", label: "Hitmonchan", id: 107 },
	{ value: "Lickitung", label: "Lickitung", id: 108 },
	{ value: "Koffing", label: "Koffing", id: 109 },
	{ value: "Weezing", label: "Weezing", id: 110 },
	{ value: "Rhyhorn", label: "Rhyhorn", id: 111 },
	{ value: "Rhydon", label: "Rhydon", id: 112 },
	{ value: "Chansey", label: "Chansey", id: 113 },
	{ value: "Tangela", label: "Tangela", id: 114 },
	{ value: "Kangaskhan", label: "Kangaskhan", id: 115 },
	{ value: "Horsea", label: "Horsea", id: 116 },
	{ value: "Seadra", label: "Seadra", id: 117 },
	{ value: "Goldeen", label: "Goldeen", id: 118 },
	{ value: "Seaking", label: "Seaking", id: 119 },
	{ value: "Staryu", label: "Staryu", id: 120 },
	{ value: "Starmie", label: "Starmie", id: 121 },
	{ value: "Mr. Mime", label: "Mr. Mime", id: 122 },
	{ value: "Scyther", label: "Scyther", id: 123 },
	{ value: "Jynx", label: "Jynx", id: 124 },
	{ value: "Electabuzz", label: "Electabuzz", id: 125 },
	{ value: "Magmar", label: "Magmar", id: 126 },
	{ value: "Pinsir", label: "Pinsir", id: 127 },
	{ value: "Tauros", label: "Tauros", id: 128 },
	{ value: "Magikarp", label: "Magikarp", id: 129 },
	{ value: "Gyarados", label: "Gyarados", id: 130 },
	{ value: "Lapras", label: "Lapras", id: 131 },
	{ value: "Ditto", label: "Ditto", id: 132 },
	{ value: "Eevee", label: "Eevee", id: 133 },
	{ value: "Vaporeon", label: "Vaporeon", id: 134 },
	{ value: "Jolteon", label: "Jolteon", id: 135 },
	{ value: "Flareon", label: "Flareon", id: 136 },
	{ value: "Porygon", label: "Porygon", id: 137 },
	{ value: "Omanyte", label: "Omanyte", id: 138 },
	{ value: "Omastar", label: "Omastar", id: 139 },
	{ value: "Kabuto", label: "Kabuto", id: 140 },
	{ value: "Kabutops", label: "Kabutops", id: 141 },
	{ value: "Aerodactyl", label: "Aerodactyl", id: 142 },
	{ value: "Snorlax", label: "Snorlax", id: 143 },
	{ value: "Articuno", label: "Articuno", id: 144 },
	{ value: "Zapdos", label: "Zapdos", id: 145 },
	{ value: "Moltres", label: "Moltres", id: 146 },
	{ value: "Dratini", label: "Dratini", id: 147 },
	{ value: "Dragonair", label: "Dragonair", id: 148 },
	{ value: "Dragonite", label: "Dragonite", id: 149 },
	{ value: "Mewtwo", label: "Mewtwo", id: 150 },
	{ value: "Mew", label: "Mew", id: 151 },
	{ value: "Chikorita", label: "Chikorita", id: 152 },
	{ value: "Bayleef", label: "Bayleef", id: 153 },
	{ value: "Meganium", label: "Meganium", id: 154 },
	{ value: "Cyndaquil", label: "Cyndaquil", id: 155 },
	{ value: "Quilava", label: "Quilava", id: 156 },
	{ value: "Typhlosion", label: "Typhlosion", id: 157 },
	{ value: "Totodile", label: "Totodile", id: 158 },
	{ value: "Croconaw", label: "Croconaw", id: 159 },
	{ value: "Feraligatr", label: "Feraligatr", id: 160 },
	{ value: "Sentret", label: "Sentret", id: 161 },
	{ value: "Furret", label: "Furret", id: 162 },
	{ value: "Hoothoot", label: "Hoothoot", id: 163 },
	{ value: "Noctowl", label: "Noctowl", id: 164 },
	{ value: "Ledyba", label: "Ledyba", id: 165 },
	{ value: "Ledian", label: "Ledian", id: 166 },
	{ value: "Spinarak", label: "Spinarak", id: 167 },
	{ value: "Ariados", label: "Ariados", id: 168 },
	{ value: "Crobat", label: "Crobat", id: 169 },
	{ value: "Chinchou", label: "Chinchou", id: 170 },
	{ value: "Lanturn", label: "Lanturn", id: 171 },
	{ value: "Pichu", label: "Pichu", id: 172 },
	{ value: "Cleffa", label: "Cleffa", id: 173 },
	{ value: "Igglybuff", label: "Igglybuff", id: 174 },
	{ value: "Togepi", label: "Togepi", id: 175 },
	{ value: "Togetic", label: "Togetic", id: 176 },
	{ value: "Natu", label: "Natu", id: 177 },
	{ value: "Xatu", label: "Xatu", id: 178 },
	{ value: "Mareep", label: "Mareep", id: 179 },
	{ value: "Flaaffy", label: "Flaaffy", id: 180 },
	{ value: "Ampharos", label: "Ampharos", id: 181 },
	{ value: "Bellossom", label: "Bellossom", id: 182 },
	{ value: "Marill", label: "Marill", id: 183 },
	{ value: "Azumarill", label: "Azumarill", id: 184 },
	{ value: "Sudowoodo", label: "Sudowoodo", id: 185 },
	{ value: "Politoed", label: "Politoed", id: 186 },
	{ value: "Hoppip", label: "Hoppip", id: 187 },
	{ value: "Skiploom", label: "Skiploom", id: 188 },
	{ value: "Jumpluff", label: "Jumpluff", id: 189 },
	{ value: "Aipom", label: "Aipom", id: 190 },
	{ value: "Sunkern", label: "Sunkern", id: 191 },
	{ value: "Sunflora", label: "Sunflora", id: 192 },
	{ value: "Yanma", label: "Yanma", id: 193 },
	{ value: "Wooper", label: "Wooper", id: 194 },
	{ value: "Quagsire", label: "Quagsire", id: 195 },
	{ value: "Espeon", label: "Espeon", id: 196 },
	{ value: "Umbreon", label: "Umbreon", id: 197 },
	{ value: "Murkrow", label: "Murkrow", id: 198 },
	{ value: "Slowking", label: "Slowking", id: 199 },
	{ value: "Misdreavus", label: "Misdreavus", id: 200 },
	{ value: "Unown", label: "Unown", id: 201 },
	{ value: "Wobbuffet", label: "Wobbuffet", id: 202 },
	{ value: "Girafarig", label: "Girafarig", id: 203 },
	{ value: "Pineco", label: "Pineco", id: 204 },
	{ value: "Forretress", label: "Forretress", id: 205 },
	{ value: "Dunsparce", label: "Dunsparce", id: 206 },
	{ value: "Gligar", label: "Gligar", id: 207 },
	{ value: "Steelix", label: "Steelix", id: 208 },
	{ value: "Snubbull", label: "Snubbull", id: 209 },
	{ value: "Granbull", label: "Granbull", id: 210 },
	{ value: "Qwilfish", label: "Qwilfish", id: 211 },
	{ value: "Scizor", label: "Scizor", id: 212 },
	{ value: "Shuckle", label: "Shuckle", id: 213 },
	{ value: "Heracross", label: "Heracross", id: 214 },
	{ value: "Sneasel", label: "Sneasel", id: 215 },
	{ value: "Teddiursa", label: "Teddiursa", id: 216 },
	{ value: "Ursaring", label: "Ursaring", id: 217 },
	{ value: "Slugma", label: "Slugma", id: 218 },
	{ value: "Magcargo", label: "Magcargo", id: 219 },
	{ value: "Swinub", label: "Swinub", id: 220 },
	{ value: "Piloswine", label: "Piloswine", id: 221 },
	{ value: "Corsola", label: "Corsola", id: 222 },
	{ value: "Remoraid", label: "Remoraid", id: 223 },
	{ value: "Octillery", label: "Octillery", id: 224 },
	{ value: "Delibird", label: "Delibird", id: 225 },
	{ value: "Mantine", label: "Mantine", id: 226 },
	{ value: "Skarmory", label: "Skarmory", id: 227 },
	{ value: "Houndour", label: "Houndour", id: 228 },
	{ value: "Houndoom", label: "Houndoom", id: 229 },
	{ value: "Kingdra", label: "Kingdra", id: 230 },
	{ value: "Phanpy", label: "Phanpy", id: 231 },
	{ value: "Donphan", label: "Donphan", id: 232 },
	{ value: "Porygon2", label: "Porygon2", id: 233 },
	{ value: "Stantler", label: "Stantler", id: 234 },
	{ value: "Smeargle", label: "Smeargle", id: 235 },
	{ value: "Tyrogue", label: "Tyrogue", id: 236 },
	{ value: "Hitmontop", label: "Hitmontop", id: 237 },
	{ value: "Smoochum", label: "Smoochum", id: 238 },
	{ value: "Elekid", label: "Elekid", id: 239 },
	{ value: "Magby", label: "Magby", id: 240 },
	{ value: "Miltank", label: "Miltank", id: 241 },
	{ value: "Blissey", label: "Blissey", id: 242 },
	{ value: "Raikou", label: "Raikou", id: 243 },
	{ value: "Entei", label: "Entei", id: 244 },
	{ value: "Suicune", label: "Suicune", id: 245 },
	{ value: "Larvitar", label: "Larvitar", id: 246 },
	{ value: "Pupitar", label: "Pupitar", id: 247 },
	{ value: "Tyranitar", label: "Tyranitar", id: 248 },
	{ value: "Lugia", label: "Lugia", id: 249 },
	{ value: "Ho-oh", label: "Ho-oh", id: 250 },
	{ value: "Celebi", label: "Celebi", id: 251 },
	{ value: "Treecko", label: "Treecko", id: 252 },
	{ value: "Grovyle", label: "Grovyle", id: 253 },
	{ value: "Sceptile", label: "Sceptile", id: 254 },
	{ value: "Torchic", label: "Torchic", id: 255 },
	{ value: "Combusken", label: "Combusken", id: 256 },
	{ value: "Blaziken", label: "Blaziken", id: 257 },
	{ value: "Mudkip", label: "Mudkip", id: 258 },
	{ value: "Marshtomp", label: "Marshtomp", id: 259 },
	{ value: "Swampert", label: "Swampert", id: 260 },
	{ value: "Poochyena", label: "Poochyena", id: 261 },
	{ value: "Mightyena", label: "Mightyena", id: 262 },
	{ value: "Zigzagoon", label: "Zigzagoon", id: 263 },
	{ value: "Linoone", label: "Linoone", id: 264 },
	{ value: "Wurmple", label: "Wurmple", id: 265 },
	{ value: "Silcoon", label: "Silcoon", id: 266 },
	{ value: "Beautifly", label: "Beautifly", id: 267 },
	{ value: "Cascoon", label: "Cascoon", id: 268 },
	{ value: "Dustox", label: "Dustox", id: 269 },
	{ value: "Lotad", label: "Lotad", id: 270 },
	{ value: "Lombre", label: "Lombre", id: 271 },
	{ value: "Ludicolo", label: "Ludicolo", id: 272 },
	{ value: "Seedot", label: "Seedot", id: 273 },
	{ value: "Nuzleaf", label: "Nuzleaf", id: 274 },
	{ value: "Shiftry", label: "Shiftry", id: 275 },
	{ value: "Taillow", label: "Taillow", id: 276 },
	{ value: "Swellow", label: "Swellow", id: 277 },
	{ value: "Wingull", label: "Wingull", id: 278 },
	{ value: "Pelipper", label: "Pelipper", id: 279 },
	{ value: "Ralts", label: "Ralts", id: 280 },
	{ value: "Kirlia", label: "Kirlia", id: 281 },
	{ value: "Gardevoir", label: "Gardevoir", id: 282 },
	{ value: "Surskit", label: "Surskit", id: 283 },
	{ value: "Masquerain", label: "Masquerain", id: 284 },
	{ value: "Shroomish", label: "Shroomish", id: 285 },
	{ value: "Breloom", label: "Breloom", id: 286 },
	{ value: "Slakoth", label: "Slakoth", id: 287 },
	{ value: "Vigoroth", label: "Vigoroth", id: 288 },
	{ value: "Slaking", label: "Slaking", id: 289 },
	{ value: "Nincada", label: "Nincada", id: 290 },
	{ value: "Ninjask", label: "Ninjask", id: 291 },
	{ value: "Shedinja", label: "Shedinja", id: 292 },
	{ value: "Whismur", label: "Whismur", id: 293 },
	{ value: "Loudred", label: "Loudred", id: 294 },
	{ value: "Exploud", label: "Exploud", id: 295 },
	{ value: "Makuhita", label: "Makuhita", id: 296 },
	{ value: "Hariyama", label: "Hariyama", id: 297 },
	{ value: "Azurill", label: "Azurill", id: 298 },
	{ value: "Nosepass", label: "Nosepass", id: 299 },
	{ value: "Skitty", label: "Skitty", id: 300 },
	{ value: "Delcatty", label: "Delcatty", id: 301 },
	{ value: "Sableye", label: "Sableye", id: 302 },
	{ value: "Mawile", label: "Mawile", id: 303 },
	{ value: "Aron", label: "Aron", id: 304 },
	{ value: "Lairon", label: "Lairon", id: 305 },
	{ value: "Aggron", label: "Aggron", id: 306 },
	{ value: "Meditite", label: "Meditite", id: 307 },
	{ value: "Medicham", label: "Medicham", id: 308 },
	{ value: "Electrike", label: "Electrike", id: 309 },
	{ value: "Manectric", label: "Manectric", id: 310 },
	{ value: "Plusle", label: "Plusle", id: 311 },
	{ value: "Minun", label: "Minun", id: 312 },
	{ value: "Volbeat", label: "Volbeat", id: 313 },
	{ value: "Illumise", label: "Illumise", id: 314 },
	{ value: "Roselia", label: "Roselia", id: 315 },
	{ value: "Gulpin", label: "Gulpin", id: 316 },
	{ value: "Swalot", label: "Swalot", id: 317 },
	{ value: "Carvanha", label: "Carvanha", id: 318 },
	{ value: "Sharpedo", label: "Sharpedo", id: 319 },
	{ value: "Wailmer", label: "Wailmer", id: 320 },
	{ value: "Wailord", label: "Wailord", id: 321 },
	{ value: "Numel", label: "Numel", id: 322 },
	{ value: "Camerupt", label: "Camerupt", id: 323 },
	{ value: "Torkoal", label: "Torkoal", id: 324 },
	{ value: "Spoink", label: "Spoink", id: 325 },
	{ value: "Grumpig", label: "Grumpig", id: 326 },
	{ value: "Spinda", label: "Spinda", id: 327 },
	{ value: "Trapinch", label: "Trapinch", id: 328 },
	{ value: "Vibrava", label: "Vibrava", id: 329 },
	{ value: "Flygon", label: "Flygon", id: 330 },
	{ value: "Cacnea", label: "Cacnea", id: 331 },
	{ value: "Cacturne", label: "Cacturne", id: 332 },
	{ value: "Swablu", label: "Swablu", id: 333 },
	{ value: "Altaria", label: "Altaria", id: 334 },
	{ value: "Zangoose", label: "Zangoose", id: 335 },
	{ value: "Seviper", label: "Seviper", id: 336 },
	{ value: "Lunatone", label: "Lunatone", id: 337 },
	{ value: "Solrock", label: "Solrock", id: 338 },
	{ value: "Barboach", label: "Barboach", id: 339 },
	{ value: "Whiscash", label: "Whiscash", id: 340 },
	{ value: "Corphish", label: "Corphish", id: 341 },
	{ value: "Crawdaunt", label: "Crawdaunt", id: 342 },
	{ value: "Baltoy", label: "Baltoy", id: 343 },
	{ value: "Claydol", label: "Claydol", id: 344 },
	{ value: "Lileep", label: "Lileep", id: 345 },
	{ value: "Cradily", label: "Cradily", id: 346 },
	{ value: "Anorith", label: "Anorith", id: 347 },
	{ value: "Armaldo", label: "Armaldo", id: 348 },
	{ value: "Feebas", label: "Feebas", id: 349 },
	{ value: "Milotic", label: "Milotic", id: 350 },
	{ value: "Castform", label: "Castform", id: 351 },
	{ value: "Kecleon", label: "Kecleon", id: 352 },
	{ value: "Shuppet", label: "Shuppet", id: 353 },
	{ value: "Banette", label: "Banette", id: 354 },
	{ value: "Duskull", label: "Duskull", id: 355 },
	{ value: "Dusclops", label: "Dusclops", id: 356 },
	{ value: "Tropius", label: "Tropius", id: 357 },
	{ value: "Chimecho", label: "Chimecho", id: 358 },
	{ value: "Absol", label: "Absol", id: 359 },
	{ value: "Wynaut", label: "Wynaut", id: 360 },
	{ value: "Snorunt", label: "Snorunt", id: 361 },
	{ value: "Glalie", label: "Glalie", id: 362 },
	{ value: "Spheal", label: "Spheal", id: 363 },
	{ value: "Sealeo", label: "Sealeo", id: 364 },
	{ value: "Walrein", label: "Walrein", id: 365 },
	{ value: "Clamperl", label: "Clamperl", id: 366 },
	{ value: "Huntail", label: "Huntail", id: 367 },
	{ value: "Gorebyss", label: "Gorebyss", id: 368 },
	{ value: "Relicanth", label: "Relicanth", id: 369 },
	{ value: "Luvdisc", label: "Luvdisc", id: 370 },
	{ value: "Bagon", label: "Bagon", id: 371 },
	{ value: "Shelgon", label: "Shelgon", id: 372 },
	{ value: "Salamence", label: "Salamence", id: 373 },
	{ value: "Beldum", label: "Beldum", id: 374 },
	{ value: "Metang", label: "Metang", id: 375 },
	{ value: "Metagross", label: "Metagross", id: 376 },
	{ value: "Regirock", label: "Regirock", id: 377 },
	{ value: "Regice", label: "Regice", id: 378 },
	{ value: "Registeel", label: "Registeel", id: 379 },
	{ value: "Latias", label: "Latias", id: 380 },
	{ value: "Latios", label: "Latios", id: 381 },
	{ value: "Kyogre", label: "Kyogre", id: 382 },
	{ value: "Groudon", label: "Groudon", id: 383 },
	{ value: "Rayquaza", label: "Rayquaza", id: 384 },
	{ value: "Jirachi", label: "Jirachi", id: 385 },
	{ value: "Deoxys", label: "Deoxys", id: 386 },
	{ value: "Turtwig", label: "Turtwig", id: 387 },
	{ value: "Grotle", label: "Grotle", id: 388 },
	{ value: "Torterra", label: "Torterra", id: 389 },
	{ value: "Chimchar", label: "Chimchar", id: 390 },
	{ value: "Monferno", label: "Monferno", id: 391 },
	{ value: "Infernape", label: "Infernape", id: 392 },
	{ value: "Piplup", label: "Piplup", id: 393 },
	{ value: "Prinplup", label: "Prinplup", id: 394 },
	{ value: "Empoleon", label: "Empoleon", id: 395 },
	{ value: "Starly", label: "Starly", id: 396 },
	{ value: "Staravia", label: "Staravia", id: 397 },
	{ value: "Staraptor", label: "Staraptor", id: 398 },
	{ value: "Bidoof", label: "Bidoof", id: 399 },
	{ value: "Bibarel", label: "Bibarel", id: 400 },
	{ value: "Kricketot", label: "Kricketot", id: 401 },
	{ value: "Kricketune", label: "Kricketune", id: 402 },
	{ value: "Shinx", label: "Shinx", id: 403 },
	{ value: "Luxio", label: "Luxio", id: 404 },
	{ value: "Luxray", label: "Luxray", id: 405 },
	{ value: "Budew", label: "Budew", id: 406 },
	{ value: "Roserade", label: "Roserade", id: 407 },
	{ value: "Cranidos", label: "Cranidos", id: 408 },
	{ value: "Rampardos", label: "Rampardos", id: 409 },
	{ value: "Shieldon", label: "Shieldon", id: 410 },
	{ value: "Bastiodon", label: "Bastiodon", id: 411 },
	{ value: "Burmy", label: "Burmy", id: 412 },
	{ value: "Wormadam", label: "Wormadam", id: 413 },
	{ value: "Mothim", label: "Mothim", id: 414 },
	{ value: "Combee", label: "Combee", id: 415 },
	{ value: "Vespiquen", label: "Vespiquen", id: 416 },
	{ value: "Pachirisu", label: "Pachirisu", id: 417 },
	{ value: "Buizel", label: "Buizel", id: 418 },
	{ value: "Floatzel", label: "Floatzel", id: 419 },
	{ value: "Cherubi", label: "Cherubi", id: 420 },
	{ value: "Cherrim", label: "Cherrim", id: 421 },
	{ value: "Shellos", label: "Shellos", id: 422 },
	{ value: "Gastrodon", label: "Gastrodon", id: 423 },
	{ value: "Ambipom", label: "Ambipom", id: 424 },
	{ value: "Drifloon", label: "Drifloon", id: 425 },
	{ value: "Drifblim", label: "Drifblim", id: 426 },
	{ value: "Buneary", label: "Buneary", id: 427 },
	{ value: "Lopunny", label: "Lopunny", id: 428 },
	{ value: "Mismagius", label: "Mismagius", id: 429 },
	{ value: "Honchkrow", label: "Honchkrow", id: 430 },
	{ value: "Glameow", label: "Glameow", id: 431 },
	{ value: "Purugly", label: "Purugly", id: 432 },
	{ value: "Chingling", label: "Chingling", id: 433 },
	{ value: "Stunky", label: "Stunky", id: 434 },
	{ value: "Skuntank", label: "Skuntank", id: 435 },
	{ value: "Bronzor", label: "Bronzor", id: 436 },
	{ value: "Bronzong", label: "Bronzong", id: 437 },
	{ value: "Bonsly", label: "Bonsly", id: 438 },
	{ value: "Mime Jr.", label: "Mime Jr.", id: 439 },
	{ value: "Happiny", label: "Happiny", id: 440 },
	{ value: "Chatot", label: "Chatot", id: 441 },
	{ value: "Spiritomb", label: "Spiritomb", id: 442 },
	{ value: "Gible", label: "Gible", id: 443 },
	{ value: "Gabite", label: "Gabite", id: 444 },
	{ value: "Garchomp", label: "Garchomp", id: 445 },
	{ value: "Munchlax", label: "Munchlax", id: 446 },
	{ value: "Riolu", label: "Riolu", id: 447 },
	{ value: "Lucario", label: "Lucario", id: 448 },
	{ value: "Hippopotas", label: "Hippopotas", id: 449 },
	{ value: "Hippowdon", label: "Hippowdon", id: 450 },
	{ value: "Skorupi", label: "Skorupi", id: 451 },
	{ value: "Drapion", label: "Drapion", id: 452 },
	{ value: "Croagunk", label: "Croagunk", id: 453 },
	{ value: "Toxicroak", label: "Toxicroak", id: 454 },
	{ value: "Carnivine", label: "Carnivine", id: 455 },
	{ value: "Finneon", label: "Finneon", id: 456 },
	{ value: "Lumineon", label: "Lumineon", id: 457 },
	{ value: "Mantyke", label: "Mantyke", id: 458 },
	{ value: "Snover", label: "Snover", id: 459 },
	{ value: "Abomasnow", label: "Abomasnow", id: 460 },
	{ value: "Weavile", label: "Weavile", id: 461 },
	{ value: "Magnezone", label: "Magnezone", id: 462 },
	{ value: "Lickilicky", label: "Lickilicky", id: 463 },
	{ value: "Rhyperior", label: "Rhyperior", id: 464 },
	{ value: "Tangrowth", label: "Tangrowth", id: 465 },
	{ value: "Electivire", label: "Electivire", id: 466 },
	{ value: "Magmortar", label: "Magmortar", id: 467 },
	{ value: "Togekiss", label: "Togekiss", id: 468 },
	{ value: "Yanmega", label: "Yanmega", id: 469 },
	{ value: "Leafeon", label: "Leafeon", id: 470 },
	{ value: "Glaceon", label: "Glaceon", id: 471 },
	{ value: "Gliscor", label: "Gliscor", id: 472 },
	{ value: "Mamoswine", label: "Mamoswine", id: 473 },
	{ value: "Porygon-Z", label: "Porygon-Z", id: 474 },
	{ value: "Gallade", label: "Gallade", id: 475 },
	{ value: "Probopass", label: "Probopass", id: 476 },
	{ value: "Dusknoir", label: "Dusknoir", id: 477 },
	{ value: "Froslass", label: "Froslass", id: 478 },
	{ value: "Rotom", label: "Rotom", id: 479 },
	{ value: "Uxie", label: "Uxie", id: 480 },
	{ value: "Mesprit", label: "Mesprit", id: 481 },
	{ value: "Azelf", label: "Azelf", id: 482 },
	{ value: "Dialga", label: "Dialga", id: 483 },
	{ value: "Palkia", label: "Palkia", id: 484 },
	{ value: "Heatran", label: "Heatran", id: 485 },
	{ value: "Regigigas", label: "Regigigas", id: 486 },
	{ value: "Giratina", label: "Giratina", id: 487 },
	{ value: "Cresselia", label: "Cresselia", id: 488 },
	{ value: "Phione", label: "Phione", id: 489 },
	{ value: "Manaphy", label: "Manaphy", id: 490 },
	{ value: "Darkrai", label: "Darkrai", id: 491 },
	{ value: "Shaymin", label: "Shaymin", id: 492 },
	{ value: "Arceus", label: "Arceus", id: 493 },
	{ value: "Victini", label: "Victini", id: 494 },
	{ value: "Snivy", label: "Snivy", id: 495 },
	{ value: "Servine", label: "Servine", id: 496 },
	{ value: "Serperior", label: "Serperior", id: 497 },
	{ value: "Tepig", label: "Tepig", id: 498 },
	{ value: "Pignite", label: "Pignite", id: 499 },
	{ value: "Emboar", label: "Emboar", id: 500 },
	{ value: "Oshawott", label: "Oshawott", id: 501 },
	{ value: "Dewott", label: "Dewott", id: 502 },
	{ value: "Samurott", label: "Samurott", id: 503 },
	{ value: "Patrat", label: "Patrat", id: 504 },
	{ value: "Watchog", label: "Watchog", id: 505 },
	{ value: "Lillipup", label: "Lillipup", id: 506 },
	{ value: "Herdier", label: "Herdier", id: 507 },
	{ value: "Stoutland", label: "Stoutland", id: 508 },
	{ value: "Purrloin", label: "Purrloin", id: 509 },
	{ value: "Liepard", label: "Liepard", id: 510 },
	{ value: "Pansage", label: "Pansage", id: 511 },
	{ value: "Simisage", label: "Simisage", id: 512 },
	{ value: "Pansear", label: "Pansear", id: 513 },
	{ value: "Simisear", label: "Simisear", id: 514 },
	{ value: "Panpour", label: "Panpour", id: 515 },
	{ value: "Simipour", label: "Simipour", id: 516 },
	{ value: "Munna", label: "Munna", id: 517 },
	{ value: "Musharna", label: "Musharna", id: 518 },
	{ value: "Pidove", label: "Pidove", id: 519 },
	{ value: "Tranquill", label: "Tranquill", id: 520 },
	{ value: "Unfezant", label: "Unfezant", id: 521 },
	{ value: "Blitzle", label: "Blitzle", id: 522 },
	{ value: "Zebstrika", label: "Zebstrika", id: 523 },
	{ value: "Roggenrola", label: "Roggenrola", id: 524 },
	{ value: "Boldore", label: "Boldore", id: 525 },
	{ value: "Gigalith", label: "Gigalith", id: 526 },
	{ value: "Woobat", label: "Woobat", id: 527 },
	{ value: "Swoobat", label: "Swoobat", id: 528 },
	{ value: "Drilbur", label: "Drilbur", id: 529 },
	{ value: "Excadrill", label: "Excadrill", id: 530 },
	{ value: "Audino", label: "Audino", id: 531 },
	{ value: "Timburr", label: "Timburr", id: 532 },
	{ value: "Gurdurr", label: "Gurdurr", id: 533 },
	{ value: "Conkeldurr", label: "Conkeldurr", id: 534 },
	{ value: "Tympole", label: "Tympole", id: 535 },
	{ value: "Palpitoad", label: "Palpitoad", id: 536 },
	{ value: "Seismitoad", label: "Seismitoad", id: 537 },
	{ value: "Throh", label: "Throh", id: 538 },
	{ value: "Sawk", label: "Sawk", id: 539 },
	{ value: "Sewaddle", label: "Sewaddle", id: 540 },
	{ value: "Swadloon", label: "Swadloon", id: 541 },
	{ value: "Leavanny", label: "Leavanny", id: 542 },
	{ value: "Venipede", label: "Venipede", id: 543 },
	{ value: "Whirlipede", label: "Whirlipede", id: 544 },
	{ value: "Scolipede", label: "Scolipede", id: 545 },
	{ value: "Cottonee", label: "Cottonee", id: 546 },
	{ value: "Whimsicott", label: "Whimsicott", id: 547 },
	{ value: "Petilil", label: "Petilil", id: 548 },
	{ value: "Lilligant", label: "Lilligant", id: 549 },
	{ value: "Basculin", label: "Basculin", id: 550 },
	{ value: "Sandile", label: "Sandile", id: 551 },
	{ value: "Krokorok", label: "Krokorok", id: 552 },
	{ value: "Krookodile", label: "Krookodile", id: 553 },
	{ value: "Darumaka", label: "Darumaka", id: 554 },
	{ value: "Darmanitan", label: "Darmanitan", id: 555 },
	{ value: "Maractus", label: "Maractus", id: 556 },
	{ value: "Dwebble", label: "Dwebble", id: 557 },
	{ value: "Crustle", label: "Crustle", id: 558 },
	{ value: "Scraggy", label: "Scraggy", id: 559 },
	{ value: "Scrafty", label: "Scrafty", id: 560 },
	{ value: "Sigilyph", label: "Sigilyph", id: 561 },
	{ value: "Yamask", label: "Yamask", id: 562 },
	{ value: "Cofagrigus", label: "Cofagrigus", id: 563 },
	{ value: "Tirtouga", label: "Tirtouga", id: 564 },
	{ value: "Carracosta", label: "Carracosta", id: 565 },
	{ value: "Archen", label: "Archen", id: 566 },
	{ value: "Archeops", label: "Archeops", id: 567 },
	{ value: "Trubbish", label: "Trubbish", id: 568 },
	{ value: "Garbodor", label: "Garbodor", id: 569 },
	{ value: "Zorua", label: "Zorua", id: 570 },
	{ value: "Zoroark", label: "Zoroark", id: 571 },
	{ value: "Minccino", label: "Minccino", id: 572 },
	{ value: "Cinccino", label: "Cinccino", id: 573 },
	{ value: "Gothita", label: "Gothita", id: 574 },
	{ value: "Gothorita", label: "Gothorita", id: 575 },
	{ value: "Gothitelle", label: "Gothitelle", id: 576 },
	{ value: "Solosis", label: "Solosis", id: 577 },
	{ value: "Duosion", label: "Duosion", id: 578 },
	{ value: "Reuniclus", label: "Reuniclus", id: 579 },
	{ value: "Ducklett", label: "Ducklett", id: 580 },
	{ value: "Swanna", label: "Swanna", id: 581 },
	{ value: "Vanillite", label: "Vanillite", id: 582 },
	{ value: "Vanillish", label: "Vanillish", id: 583 },
	{ value: "Vanilluxe", label: "Vanilluxe", id: 584 },
	{ value: "Deerling", label: "Deerling", id: 585 },
	{ value: "Sawsbuck", label: "Sawsbuck", id: 586 },
	{ value: "Emolga", label: "Emolga", id: 587 },
	{ value: "Karrablast", label: "Karrablast", id: 588 },
	{ value: "Escavalier", label: "Escavalier", id: 589 },
	{ value: "Foongus", label: "Foongus", id: 590 },
	{ value: "Amoonguss", label: "Amoonguss", id: 591 },
	{ value: "Frillish", label: "Frillish", id: 592 },
	{ value: "Jellicent", label: "Jellicent", id: 593 },
	{ value: "Alomomola", label: "Alomomola", id: 594 },
	{ value: "Joltik", label: "Joltik", id: 595 },
	{ value: "Galvantula", label: "Galvantula", id: 596 },
	{ value: "Ferroseed", label: "Ferroseed", id: 597 },
	{ value: "Ferrothorn", label: "Ferrothorn", id: 598 },
	{ value: "Klink", label: "Klink", id: 599 },
	{ value: "Klang", label: "Klang", id: 600 },
	{ value: "Klinklang", label: "Klinklang", id: 601 },
	{ value: "Tynamo", label: "Tynamo", id: 602 },
	{ value: "Eelektrik", label: "Eelektrik", id: 603 },
	{ value: "Eelektross", label: "Eelektross", id: 604 },
	{ value: "Elgyem", label: "Elgyem", id: 605 },
	{ value: "Beheeyem", label: "Beheeyem", id: 606 },
	{ value: "Litwick", label: "Litwick", id: 607 },
	{ value: "Lampent", label: "Lampent", id: 608 },
	{ value: "Chandelure", label: "Chandelure", id: 609 },
	{ value: "Axew", label: "Axew", id: 610 },
	{ value: "Fraxure", label: "Fraxure", id: 611 },
	{ value: "Haxorus", label: "Haxorus", id: 612 },
	{ value: "Cubchoo", label: "Cubchoo", id: 613 },
	{ value: "Beartic", label: "Beartic", id: 614 },
	{ value: "Cryogonal", label: "Cryogonal", id: 615 },
	{ value: "Shelmet", label: "Shelmet", id: 616 },
	{ value: "Accelgor", label: "Accelgor", id: 617 },
	{ value: "Stunfisk", label: "Stunfisk", id: 618 },
	{ value: "Mienfoo", label: "Mienfoo", id: 619 },
	{ value: "Mienshao", label: "Mienshao", id: 620 },
	{ value: "Druddigon", label: "Druddigon", id: 621 },
	{ value: "Golett", label: "Golett", id: 622 },
	{ value: "Golurk", label: "Golurk", id: 623 },
	{ value: "Pawniard", label: "Pawniard", id: 624 },
	{ value: "Bisharp", label: "Bisharp", id: 625 },
	{ value: "Bouffalant", label: "Bouffalant", id: 626 },
	{ value: "Rufflet", label: "Rufflet", id: 627 },
	{ value: "Braviary", label: "Braviary", id: 628 },
	{ value: "Vullaby", label: "Vullaby", id: 629 },
	{ value: "Mandibuzz", label: "Mandibuzz", id: 630 },
	{ value: "Heatmor", label: "Heatmor", id: 631 },
	{ value: "Durant", label: "Durant", id: 632 },
	{ value: "Deino", label: "Deino", id: 633 },
	{ value: "Zweilous", label: "Zweilous", id: 634 },
	{ value: "Hydreigon", label: "Hydreigon", id: 635 },
	{ value: "Larvesta", label: "Larvesta", id: 636 },
	{ value: "Volcarona", label: "Volcarona", id: 637 },
	{ value: "Cobalion", label: "Cobalion", id: 638 },
	{ value: "Terrakion", label: "Terrakion", id: 639 },
	{ value: "Virizion", label: "Virizion", id: 640 },
	{ value: "Tornadus", label: "Tornadus", id: 641 },
	{ value: "Thundurus", label: "Thundurus", id: 642 },
	{ value: "Reshiram", label: "Reshiram", id: 643 },
	{ value: "Zekrom", label: "Zekrom", id: 644 },
	{ value: "Landorus", label: "Landorus", id: 645 },
	{ value: "Kyurem", label: "Kyurem", id: 646 },
	{ value: "Keldeo", label: "Keldeo", id: 647 },
	{ value: "Meloetta", label: "Meloetta", id: 648 },
	{ value: "Genesect", label: "Genesect", id: 649 },
	{ value: "Chespin", label: "Chespin", id: 650 },
	{ value: "Quilladin", label: "Quilladin", id: 651 },
	{ value: "Chesnaught", label: "Chesnaught", id: 652 },
	{ value: "Fennekin", label: "Fennekin", id: 653 },
	{ value: "Braixen", label: "Braixen", id: 654 },
	{ value: "Delphox", label: "Delphox", id: 655 },
	{ value: "Froakie", label: "Froakie", id: 656 },
	{ value: "Frogadier", label: "Frogadier", id: 657 },
	{ value: "Greninja", label: "Greninja", id: 658 },
	{ value: "Bunnelby", label: "Bunnelby", id: 659 },
	{ value: "Diggersby", label: "Diggersby", id: 660 },
	{ value: "Fletchling", label: "Fletchling", id: 661 },
	{ value: "Fletchinder", label: "Fletchinder", id: 662 },
	{ value: "Talonflame", label: "Talonflame", id: 663 },
	{ value: "Scatterbug", label: "Scatterbug", id: 664 },
	{ value: "Spewpa", label: "Spewpa", id: 665 },
	{ value: "Vivillon", label: "Vivillon", id: 666 },
	{ value: "Litleo", label: "Litleo", id: 667 },
	{ value: "Pyroar", label: "Pyroar", id: 668 },
	{ value: "Flabebe", label: "Flabebe", id: 669 },
	{ value: "Floette", label: "Floette", id: 670 },
	{ value: "Florges", label: "Florges", id: 671 },
	{ value: "Skiddo", label: "Skiddo", id: 672 },
	{ value: "Gogoat", label: "Gogoat", id: 673 },
	{ value: "Pancham", label: "Pancham", id: 674 },
	{ value: "Pangoro", label: "Pangoro", id: 675 },
	{ value: "Furfrou", label: "Furfrou", id: 676 },
	{ value: "Espurr", label: "Espurr", id: 677 },
	{ value: "Meowstic", label: "Meowstic", id: 678 },
	{ value: "Honedge", label: "Honedge", id: 679 },
	{ value: "Doublade", label: "Doublade", id: 680 },
	{ value: "Aegislash", label: "Aegislash", id: 681 },
	{ value: "Spritzee", label: "Spritzee", id: 682 },
	{ value: "Aromatisse", label: "Aromatisse", id: 683 },
	{ value: "Swirlix", label: "Swirlix", id: 684 },
	{ value: "Slurpuff", label: "Slurpuff", id: 685 },
	{ value: "Inkay", label: "Inkay", id: 686 },
	{ value: "Malamar", label: "Malamar", id: 687 },
	{ value: "Binacle", label: "Binacle", id: 688 },
	{ value: "Barbaracle", label: "Barbaracle", id: 689 },
	{ value: "Skrelp", label: "Skrelp", id: 690 },
	{ value: "Dragalge", label: "Dragalge", id: 691 },
	{ value: "Clauncher", label: "Clauncher", id: 692 },
	{ value: "Clawitzer", label: "Clawitzer", id: 693 },
	{ value: "Helioptile", label: "Helioptile", id: 694 },
	{ value: "Heliolisk", label: "Heliolisk", id: 695 },
	{ value: "Tyrunt", label: "Tyrunt", id: 696 },
	{ value: "Tyrantrum", label: "Tyrantrum", id: 697 },
	{ value: "Amaura", label: "Amaura", id: 698 },
	{ value: "Aurorus", label: "Aurorus", id: 699 },
	{ value: "Sylveon", label: "Sylveon", id: 700 },
	{ value: "Hawlucha", label: "Hawlucha", id: 701 },
	{ value: "Dedenne", label: "Dedenne", id: 702 },
	{ value: "Carbink", label: "Carbink", id: 703 },
	{ value: "Goomy", label: "Goomy", id: 704 },
	{ value: "Sliggoo", label: "Sliggoo", id: 705 },
	{ value: "Goodra", label: "Goodra", id: 706 },
	{ value: "Klefki", label: "Klefki", id: 707 },
	{ value: "Phantump", label: "Phantump", id: 708 },
	{ value: "Trevenant", label: "Trevenant", id: 709 },
	{ value: "Pumpkaboo", label: "Pumpkaboo", id: 710 },
	{ value: "Gourgeist", label: "Gourgeist", id: 711 },
	{ value: "Bergmite", label: "Bergmite", id: 712 },
	{ value: "Avalugg", label: "Avalugg", id: 713 },
	{ value: "Noibat", label: "Noibat", id: 714 },
	{ value: "Noivern", label: "Noivern", id: 715 },
	{ value: "Xerneas", label: "Xerneas", id: 716 },
	{ value: "Yveltal", label: "Yveltal", id: 717 },
	{ value: "Zygarde", label: "Zygarde", id: 718 },
	{ value: "Diancie", label: "Diancie", id: 719 },
	{ value: "Hoopa", label: "Hoopa", id: 720 },
	{ value: "Volcanion", label: "Volcanion", id: 721 }
];

export default Options;


// WEBPACK FOOTER //
// ./src/services/optionList.js